import axios from 'axios';

export default {
    methods: {
        async usersTable(d, ok, err) {
            try {
                let r = await axios.get('users/table?page=' + d.page, {params: d});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async getActiveUser(ok, err) {
            try {
                let r = await axios.get('user');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async usersList(ok, err) {
            try {
                let r = await axios.post('users/list');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async usersHijos(d, ok, err) {
            try {
                let r = await axios.post('users/hijos', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async getUserEmpresas(ok) {
            try {
                let r = await axios.post('users/empresas')
                ok(r.data)
            } catch (e) {
                console.log(e)
            }
        },
        async getVendedores(ok, err) {
            try {
                let r = await axios.post('users/vendedores');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async getDistribuidores(ok, err) {
            try {
                let r = await axios.post('users/distribuidores');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async userRoles(d, ok, err) {
            try {
                let r = await axios.post('users/roles', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async userAsginarRoles(d, ok, err) {
            try {
                let r = await axios.post('users/roles-asignar', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async userQuitarRoles(d, ok, err) {
            try {
                let r = await axios.post('users/roles-quitar', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async userSyncRoles(d, ok, err) {
            try {
                let r = await axios.post('users/sync-roles', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async vendedorVinculado(d, ok, err) {
            try {
                let r = await axios.post('users/vendedor-vinculado', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async userPermissions(d, ok, err) {
            try {
                let r = await axios.post('users/permissions', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async userPermissionAttach(d, ok, err) {
            try {
                let r = await axios.post('users/permission-attach', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async userPermissionSync(d, ok, err) {
            try {
                let r = await axios.post('users/permission-sync', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async userHijosSync(d, ok, err) {
            try {
                let r = await axios.post('users/hijos-sync', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async userDescuentoSet(d, ok, err) {
            try {
                let r = await axios.post('users/descuento-set', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async userDescuentoGet(d, ok, err) {
            try {
                let r = await axios.post('users/descuento-get', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async userAvatar(ok, err) {
            try {
                let r = await axios.post('users/avatar');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/auth/users.js